var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Controller, useFormContext } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import { ErrorMessageDisplay } from '../../../atoms/Input';
export const TextInputController = props => {
    const { errors } = useFormContext();
    const { rules } = props, filteredProps = __rest(props, ["rules"]);
    return (_jsxs(_Fragment, { children: [_jsx(Controller, { rules: rules, name: props.name, defaultValue: props.defaultValue, render: ({ value, onChange, onBlur }) => (_jsx("input", Object.assign({ id: props.id || props.name, onBlur: (e) => {
                        onBlur();
                        props.onBlur && props.onBlur(e);
                    }, value: value, onChange: onChange }, filteredProps))) }), !props.hideErrors && (_jsx(ErrorMessage, { errors: errors, name: props.name, render: ({ message }) => (_jsx(ErrorMessageDisplay, { id: props.id || props.name, message: message })) }))] }));
};
